import React from 'react';
import Icon from '@pushpay/icon';
import { createUseStyles, clsx } from '@pushpay/styles';
const useStyles = createUseStyles({
  root: {},
  svg: {
    strokeDasharray: 70,
    strokeDashoffset: 70,
    strokeWidth: 2
  },
  circle: ({
    animationDuration
  }) => ({
    transform: 'rotate(180deg)',
    transformOrigin: 'center',
    animation: `$circle ${animationDuration}ms ease-out forwards`
  }),
  checkmark: ({
    animationDuration,
    animationDelay
  }) => ({
    transform: 'rotate(-45deg)',
    animation: `$checkmark ${animationDuration * 2}ms ease-out ${animationDelay * 2}ms forwards`
  }),
  '@keyframes circle': {
    from: {
      strokeDashoffset: 70
    },
    to: {
      strokeDashoffset: 140
    }
  },
  '@keyframes checkmark': {
    to: {
      strokeDashoffset: 0
    }
  }
});

const AnimatedSuccessIcon = ({
  animationDuration = 500,
  animationDelay = 300,
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp, {
    animationDuration,
    animationDelay
  });
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("circle", {
    className: clsx(classes.svg, classes.circle),
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    className: clsx(classes.svg, classes.checkmark),
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5 14V18 H6"
  })));
};

export default AnimatedSuccessIcon;